import React from 'react'
import { Helmet } from 'react-helmet'

import { useThemeContext } from '../../../../../contexts'

export const ThemeCss: React.FC = () => {
  const { theme } = useThemeContext()
  const isEnabled = theme?.Style?.IsEnabled && theme?.IsEnabled
  const css = theme?.Style?.Value || ''

  // If theme is deactivated delete the previous theme in style tag
  if (!isEnabled || !css) {
    const element = document.getElementById('theme-css')
    if (element) element.remove()
    return null
  }

  return (
    <Helmet>
      <style id="theme-css">{css}</style>
    </Helmet>
  )
}
